import { JxtRouterContext, ParamParseKey, PathMatch, PathPattern } from '@jooxter/core';
import { useMemo } from 'react';
import { Navigate, Outlet, useLocation, useNavigate, matchPath as rrMatchPath } from 'react-router';

export const JxtWebRouterProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // react-router's ParamParseKey is structurally identical to @jooxter/core's but declared in a
  // separate module, so TS can't reconcile the two conditional types while Path is still generic.
  // Re-typing through @jooxter/core's own aliases here keeps JxtRouterContext framework-agnostic.
  const matchPath = useMemo(
    () =>
      <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string): PathMatch<ParamParseKey<Path>> | null =>
        rrMatchPath(pattern, pathname) as PathMatch<ParamParseKey<Path>> | null,
    []
  );

  const value = useMemo(() => ({ navigate, location, Outlet, Navigate, matchPath }), [navigate, location, matchPath]);

  return <JxtRouterContext.Provider value={value}>{children}</JxtRouterContext.Provider>;
};
